export default __webpack_public_path__ + "static/media/caret-down-green.355c293a.svg";